// import React, { useState } from 'react';
// import Sidebar from './admincomponents/Sidebar';
// import Navbar from './admincomponents/Navbar';
// import Dashboard from './adminpages/Dashboard';
// import UserManagement from './adminpages/UserManagement';
// import InstructorManagement from './adminpages/InstructorManagement';
// import CourseApproval from './adminpages/CourseApproval';
// import GroupManagement from './adminpages/GroupManagement';
// import ReportsAnalytics from './adminpages/ReportsAnalytics';
// import BillingPayments from './adminpages/BillingPayments';
// import AccessControl from './adminpages/AccessControl';

// function App() {
//   const [activeMenu, setActiveMenu] = useState('dashboard');
//   const [sidebarOpen, setSidebarOpen] = useState(true);

//   const toggleSidebar = () => {
//     setSidebarOpen(!sidebarOpen);
//   };

//   const renderContent = () => {
//     switch (activeMenu) {
//       case 'dashboard':
//         return <Dashboard />;
//       case 'user-management':
//         return <UserManagement />;
//       case 'instructor-management':
//         return <InstructorManagement />;
//       case 'course-approval':
//         return <CourseApproval />;
//       case 'group-management':
//         return <GroupManagement />;
//       case 'reports-analytics':
//         return <ReportsAnalytics />;
//       case 'billing-payments':
//         return <BillingPayments />;
//       case 'access-control':
//         return <AccessControl />;
//       default:
//         return <Dashboard />;
//     }
//   };

//   return (
//     <div style={{ 
//       display: 'flex', 
//       height: '100vh', 
//       overflow: 'hidden',
//       fontFamily: 'Arial, sans-serif'
//     }}>
//       <Sidebar 
//         activeMenu={activeMenu} 
//         setActiveMenu={setActiveMenu} 
//         isOpen={sidebarOpen}
//       />
//       <div style={{ 
//         flex: 1, 
//         display: 'flex', 
//         flexDirection: 'column',
//         overflow: 'hidden'
//       }}>
//         <Navbar toggleSidebar={toggleSidebar} />
//         <main style={{ 
//           flex: 1, 
//           padding: '20px', 
//           overflowY: 'auto',
//           background: 'linear-gradient(135deg, rgba(255,240,255,0.1), rgba(240,240,255,0.3))'
//         }}>
//           {renderContent()}
//         </main>
//       </div>
//     </div>
//   );
// }

// export default App;
import React, { useState } from 'react';
import { useNavigate, Routes, Route, useLocation } from 'react-router-dom';
import Sidebar from './admincomponents/Sidebar';
import Navbar from './admincomponents/Navbar';
import Dashboard from './adminpages/Dashboard';
import UserManagement from './adminpages/UserManagement';
import InstructorManagement from './adminpages/InstructorManagement';
import CourseApproval from './adminpages/CourseApproval';
import GroupManagement from './adminpages/GroupManagement';
import ReportsAnalytics from './adminpages/ReportsAnalytics';
import BillingPayments from './adminpages/BillingPayments';
import AccessControl from './adminpages/AccessControl';
import CourseAssignment from './adminpages/Courseassignment';
import AdminMasterPage from './adminpages/Createmaster';
import CategoryPage from './adminpages/Master/Master/Createcategory'
import DesignationManager from './adminpages/Master/Master/CreateDegination';
import AdminCreateMembership from './adminpages/CreateMembership';
import EducationManager from './adminpages/Master/Master/CreateEducation';
import OccupationManager from './adminpages/Master/Master/createOccupation';
import DepartmentManager from './adminpages/Master/Master/CreateDepartment';
import SubdivisionManager from './adminpages/Master/Master/CreateSubdivion';
import DivisionManager from './adminpages/Master/Master/CreateDivison';
import TmsDashboard from './TmsPages/TmsDashboard';
function App() {
  const [activeMenu, setActiveMenu] = useState('dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(true);
const navigate = useNavigate();
  const location = useLocation();
 
  if (!localStorage.getItem("jwttoken")) {
    window.location.href = "/Log";
    return null; // Prevent rendering protected UI
  }
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleMenuClick = (menuId) => {
    if (menuId === 'tmsdashboard') {
      navigate('/tmsdashboard');
    } else {
      setActiveMenu(menuId);
    }
  };
 
  const renderContent = () => {
    switch (activeMenu) {
      case 'dashboard':
        return <Dashboard />;
      case 'user-management':
        return <UserManagement />;
      case 'course-assignment':
        return <CourseAssignment/>;
      case 'instructor-management':
        return <InstructorManagement />;
      case 'admin-master':
          return <AdminMasterPage />; 
      case 'create-category':
          return <CategoryPage/>;  
      case 'create-occupation':
          return <OccupationManager />;
      case 'create-department':
          return <DepartmentManager />;
       case 'create-designation':
          return <DesignationManager/>;
      case 'create-division':
        return<DivisionManager/>
      case 'create-subdivision':
        return<SubdivisionManager/>
       case 'create-education':
          return <EducationManager/>;
   
       
       
      case 'course-approval':
        return <CourseApproval />;
      case 'group-management':
        return <GroupManagement />;
      case 'reports-analytics':
        return <ReportsAnalytics />;
      case 'billing-payments':
        return <BillingPayments />;
      case 'create-membership':
        return <AdminCreateMembership />;
      default:
        return <Dashboard />;
    }
  };

  return (
    <div style={{ 
      display: 'flex', 
      height: '100vh', 
      overflow: 'hidden',
      fontFamily: 'Arial, sans-serif'
    }}>
      <Sidebar 
        activeMenu={activeMenu} 
        setActiveMenu={handleMenuClick}
        isOpen={sidebarOpen}
      />
      <div style={{ 
        flex: 1, 
        display: 'flex', 
        flexDirection: 'column',
        overflow: 'hidden'
      }}>
        <Navbar toggleSidebar={toggleSidebar} />
        <main style={{ 
          flex: 1, 
          padding: '20px', 
          overflowY: 'auto',
          background: 'linear-gradient(135deg, rgba(255,240,255,0.1), rgba(240,240,255,0.3))'
        }}>
          {renderContent()}
        </main>
      </div>
      <Routes>
    <Route path="/tmsdashboard" element={<TmsDashboard />} />
  </Routes>
    </div>
  );
}

export default App;